module.exports = __webpack_public_path__ + "media/img/icons/cart-69883177c702ecbe79acf89350701ee6.png";